<div class="orders-table-row heads" *ngIf="!isMobile" [class.fixed]="isScrollingHorizontal">
  <span *ngFor="let head of heads" [innerHTML]="head"></span>
</div>
<ng-content></ng-content>
